import React, { useState , useEffect} from "react";
import { BiCheck, BiPlus, BiMinus } from "react-icons/bi";
import { getTotalMinted } from "../contracts/functions";

import LoadingSpinner from "./Loader/Loader";
import ProgressBar from "./Progressbar/Progressbar";
import styles from "./GetYourNft.module.css";
import MyCountDown from "./CountDown/CountDown";

const GetYourNft = () => {
  const [mint, setMint] = useState(16);
  const [currency, setCurrency] = useState(0);
  const [minting, setMinting] = useState(false);
  const [totalRaised, settotalRaised] = useState(0);

  const setValues = async ()  => {
    settotalRaised(await Promise.all([getTotalMinted()]));
  }

  useEffect(() => {
    setValues();
  })

  const increase = () => {
    if (mint < 16) {
      setMint((prev) => prev + 1);
    }
  };
  const decrease = () => {
    if (mint > 0) {
      setMint((prev) => prev - 1);
    }
  };
  const currencies = ["luna", "ust"];
  return (
    <section className={styles.getYourNft}>
      <div className={styles.headingAndLive}>
        <h3 className={styles.heading}>Get your NFT</h3>
        <div className={styles.timerContainer}>
          <div className={styles.timer}>
            <span className={styles.circle} />
            <span className={styles.live}>Live</span>
            <span className={`${styles.live} ${styles.time}`}>
              {" "}
              <MyCountDown dayCount="Oct 01 2022 05:30:01" />{" "}
            </span>
          </div>
        </div>
      </div>
      <div className={styles.mintingWrapper}>
        <p className={styles.mintingDate}>
          <span className={styles.key}> Minting date : </span>
          <spna className={styles.value}>
            Nov 19 2:00am - Dec 17 2:00am CET
          </spna>
        </p>{" "}
        <p className={styles.mintingDate}>
          <span className={styles.key}> Price : </span>
          <spna className={styles.value}>
            120 $UST <span className={styles.key}>or</span> 2 $LUNA
          </spna>
        </p>
      </div>
      <h5 className={styles.title}>
        How many NFTs to mint?{" "}
        <span className={styles.maxMint}>Max mint: 16</span>
      </h5>
      <div className={styles.mintContainer}>
        <BiMinus
          onClick={decrease}
          className={`${styles.mint} ${mint === 0 && styles.mintDeactive}`}
        />
        <span className={styles.mint}>{mint}</span>{" "}
        <BiPlus
          onClick={increase}
          className={`${styles.mint} ${mint === 16 && styles.mintDeactive}`}
        />
      </div>
      <h5 className={styles.title}>Which Currency to spend? </h5>
      <div className={styles.currencyContainer}>
        {currencies.map((item, i) => (
          <div
            className={`${styles.currency} ${
              currency === i && styles.currencyActive
            }`}
            key={i}
            onClick={() => setCurrency(i)}
          >
            {currency === i && <BiCheck className={styles.ok} />} {item}
          </div>
        ))}
      </div>
      <button
        className={styles.loader}
        onClick={() => {
          setMinting(true);
          setTimeout(() => {
            setMinting(false);
          }, 5000);
        }}
      >
        {minting ? (
          <LoadingSpinner />
        ) : (
          <span className={styles.minting}>MINT</span>
        )}
      </button>
      <div className={styles.transaction}>
        <p className={styles.transactionKey}>Transaction Fee</p>
        <p className={`${styles.transactionValue} ${styles.transactionKey}`}>
          ~0.07$ BNB
        </p>
      </div>
      <div className={`${styles.transaction} ${styles.transactionBottom}`}>
        <p className={styles.transactionKey}>Total Fee</p>
        <p className={`${styles.transactionValue} ${styles.transactionKey}`}>
          42.00 USDT
        </p>
      </div>{" "}
      <div className={styles.progressAndMinted}>
        <ProgressBar bgcolor="#404042" progress={880} max={2000} height={10} />
        <div className={styles.mintedContainer}>
          <p className={styles.minted}>Globally minted</p>
          <p className={styles.minted}>880 / 2,000</p>
        </div>
      </div>{" "}
      <div className={styles.progressAndMinted}>
        <ProgressBar bgcolor="#404042" progress={mint} max={16} height={10} />
        <div className={styles.mintedContainer}>
          <p className={styles.minted}>Globally minted</p>
          <p className={styles.minted}>{totalRaised} / 10000</p>
        </div>
      </div>
    </section>
  );
};

export default GetYourNft;
